
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(isWheelTirePackages, badge, badgeIndex) {
                    return _createElement('span', {
                        'className': 'badge badge--bottom-left color-accent-1 cm_badge cm_badge__' + this.toKebabCase(badge),
                        'key': badge
                    }, '\n            ', badge, '\n          ');
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatI3(isWheelTirePackages, i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                function scopeProduct4(isWheelTirePackages) {
                    var product = this.productData ?? this;
                    return [product.is_autosync_allowed ? _createElement('button', {
                            'className': 'cm_view-on-vehicle-btn button button--secondary',
                            'onClick': () => window.Convermax.openAutoSyncDialog(product.autosync_id, product.autosync_mpn, product.FitmentType?.includes('Tire')),
                            'type': 'button',
                            'key': '53281'
                        }, '\n    ', _translate(`view_product_on_vehicle`), '\n  ') : null];
                }
                function scopeIsWheelTirePackages5() {
                    var isWheelTirePackages = window.Convermax.isVehicleSelected() && this.wheel_tire_diameter && (window.location.pathname === '/collections/rim-tire-packages' || window.location.href.includes('WheelProductID'));
                    return _createElement('div', { 'className': 'card-wrapper underline-links-hover' }, _createElement('a', {
                        'href': this.url,
                        'className': 'card card--standard card--media'
                    }, _createElement('div', { 'className': 'card__inner gradient' }, _createElement('div', { 'className': 'card__media' }, _createElement('div', { 'className': 'media--transparent media--hover-effect' }, _createElement('img', {
                        'className': 'motion-reduce',
                        'data-sizes': 'auto',
                        'src': this.imageOrDefault(this.resizeImage(this.image)),
                        'alt': this.removeHTML(this.title),
                        'onError': this.onImageError
                    }))), _createElement.apply(this, [
                        'div',
                        { 'className': 'card__badge top left' },
                        this.on_sale ? _createElement('span', {
                            'className': 'badge badge--bottom-left color-accent-1',
                            'key': '794'
                        }, 'Sale') : null,
                        this._badges ? _map(this._badges.filter(b => b !== 'Hub Rings Required'), repeatBadge1.bind(this, isWheelTirePackages)) : null
                    ])), _createElement('div', { 'className': 'card__content' }, _createElement('div', { 'className': 'card__information' }, _createElement('h3', { 'className': 'card__heading h5' }, _createElement('a', mergeProps({
                        'href': this.url,
                        'className': 'full-unstyled-link'
                    }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } }))), _createElement('div', { 'className': 'card-information' }, _createElement('div', { 'className': 'price' + (this.on_sale ? ' price--on-sale' : '') }, _createElement('div', { 'className': 'price__container' }, !this.on_sale ? _createElement('div', {
                        'className': 'price__regular',
                        'key': '1689'
                    }, this.price_varies ? _createElement('span', { 'key': '1758' }, _translate(`price_from`), ' ') : null, _createElement('span', { 'className': 'price-item price-item--regular' }, this.formatPrice(this.min_price || this.price)), this.set_qty && !this.price_varies ? _createElement('div', {
                        'className': 'price-item price-item--regular price-item--set',
                        'key': '1963'
                    }, '\n                    ', _translate(`product_set_of`, {  count: this.set_qty  }), ': ', this.formatPrice(this.price * this.set_qty), '\n                  ') : null) : null, this.on_sale ? _createElement('div', {
                        'className': 'price__sale',
                        'key': '2263'
                    }, _createElement('span', { 'className': 'price-item price-item--last price-item--sale' }, '\n                    ', this.formatPrice(this.price), '\n                  '), _createElement('span', { 'className': 'price-item price-item--regular' }, '\n                     ', _createElement('del', {}, this.formatPrice(this.compare_at_price))), this.set_qty && !this.price_varies ? _createElement('div', {
                        'className': 'price-item price-item--last price-item--sale price-item--set',
                        'key': '2656'
                    }, '\n                    ', _translate(`product_set_of`, {  count: this.set_qty  }), ': ', this.formatPrice(this.price * this.set_qty), '\n                  ') : null) : null))), [this.review_count ? _createElement.apply(this, [
                            'div',
                            {
                                'className': 'cm_review-stars',
                                'key': '30210'
                            },
                            _map([
                                0,
                                1,
                                2,
                                3,
                                4
                            ], repeatI3.bind(this, isWheelTirePackages)),
                            _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                        ]) : null]), !isWheelTirePackages ? _createElement('form', {
                        'action': '/cart/add',
                        'method': 'post',
                        'className': 'cm_product-item__buttons-form',
                        'id': this.id,
                        'encType': 'multipart/form-data',
                        'key': '3441'
                    }, this.variant_ids.length > 1 ? [_createElement('a', {
                            'className': 'cm_button cm_button__secondary button button--full-width button--secondary',
                            'href': this.url,
                            'aria-label': 'button',
                            'key': '36031'
                        }, '\n              ', this.out_of_stock ? _translate(`product_out_of_stock`) : _translate(`product_select_options`), '\n            ')] : null, this.variant_ids.length === 1 ? [
                        _createElement('input', {
                            'type': 'hidden',
                            'name': 'id',
                            'value': this.variant_ids,
                            'key': '39551'
                        }),
                        _createElement('input', {
                            'type': 'hidden',
                            'name': 'quantity',
                            'value': this.set_qty || 1,
                            'key': '39553'
                        }),
                        this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                            'type': 'hidden',
                            'name': 'properties[Fitment]',
                            'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                            'key': '39555'
                        }) : null,
                        _createElement('button', {
                            'className': 'cm_button cm_button__primary button button--full-width button--primary',
                            'type': 'submit',
                            'data-form-id': this.id,
                            'disabled': this.out_of_stock,
                            'key': '39557'
                        }, this.out_of_stock ? [_translate(`product_out_of_stock`)] : null, !this.out_of_stock ? [
                            _translate(`product_add_to_cart`),
                            this.set_qty ? ` ${ _translate(`product_set_of`, {  count: this.set_qty  }) }` : ''
                        ] : null)
                    ] : null) : null, this.price ? _createElement('p', {
                        'className': 'affirm-as-low-as',
                        'data-amount': this.price * 100,
                        'data-affirm-type': 'logo',
                        'data-affirm-color': 'blue',
                        'key': '4927'
                    }) : null)), isWheelTirePackages ? _createElement('button', {
                        'className': 'cm_wheel-tire-package-button button button--primary',
                        'onClick': window.Convermax.mountedPackagesAddToCartWithRedirect(this.id, this.variant_ids[0]),
                        'key': '5084'
                    }, '\n      Get as Package\n    ') : null, [scopeProduct4.apply(this, [isWheelTirePackages])]);
                }
                return _createElement('li', { 'className': 'item' }, scopeIsWheelTirePackages5.apply(this, []));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'grid cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []